<template lang="pug">
    svg(width="52" height="52" viewBox="0 0 52 52" fill="none")
        path(d="M25.9998 42.6111C35.1738 42.6111 42.6109 35.1741 42.6109 26C42.6109 16.826 35.1738 9.38892 25.9998 9.38892C16.8257 9.38892 9.38867 16.826 9.38867 26C9.38867 35.1741 16.8257 42.6111 25.9998 42.6111Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10")
        path(d="M16.5249 17.2757C20.2097 17.2314 21.7776 15.9165 22.5793 14.8592" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path(d="M33.3952 34.3496C33.3952 32.4776 31.3246 29.2066 25.9924 29.3446C20.9557 29.4754 18.6113 32.6076 18.6113 34.4803C18.6113 36.353 21.6959 33.3168 25.8697 33.4027C30.4319 33.4966 33.4024 36.2216 33.4024 34.3496H33.3952Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10")
        path(d="M35.4748 17.2757C31.79 17.2314 30.2221 15.9165 29.4204 14.8592" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path(d="M34.8392 22.0335C30.3622 23.0951 29.7266 22.7983 28.4346 20.6172" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
        path(d="M17.1597 22.0335C21.6367 23.0951 22.2723 22.7983 23.5643 20.6172" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            color: VueTypes.string.def('#cecece')
        }
    };
</script>
